console.log('%cBuilt by Not selling liquid', 'color:#000; font-weight:bold;');

class PredictiveSearch extends HTMLElement{
  constructor(){
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('focus', this.debounce((event) => {
      document.querySelector('body').classList.add('open-mobile-search');
    }).bind(this));
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange(){
    const searchTerm = this.input.value.trim();
    if(!searchTerm.length){
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm){
    // Explicit fields keep products on Shopify's defaults (never the description) and match pages on title
    const types = this.dataset.resourceTypes || 'product';
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=${types}&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor&section_id=predictive-search`)
    .then((response) => {
      if(!response.ok){
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open(){
    this.predictiveSearchResults.closest(".search-wrapper").classList.add("active");
    document.querySelector('.snippet-search-bar').classList.add('active-search-results');
  }
  close(){
    this.predictiveSearchResults.closest(".search-wrapper").classList.remove("active");
    document.querySelector('.snippet-search-bar').classList.remove('active-search-results');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
class LocalizationForm extends HTMLElement{
  constructor(){
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    };
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  onItemClick(event){
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if(form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);
if(document.querySelectorAll('.ftr-lang-title')) document.querySelectorAll('.ftr-lang-title').forEach(function (lang_head) {
  lang_head.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    const parentForm = lang_head.closest('localization-form');
    if(parentForm.classList.contains('active')){
      parentForm.classList.remove('active');
    }else{
      document.querySelectorAll('.ftr-lang-title').forEach(function (remve_lang_head) {
        remve_lang_head.closest('localization-form').classList.remove('active');
      });
      parentForm.classList.add('active');
    }
  });
});
if(document.querySelectorAll('.ftr-lang-close')) document.querySelectorAll('.ftr-lang-close').forEach(function (lang_head){
  lang_head.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll('.ftr-lang-title').forEach(function (remve_lang_head){
      remve_lang_head.closest('localization-form').classList.remove('active');
    });
  });
});
document.body.addEventListener('click', function () {
  document.querySelectorAll('.ftr-lang-title').forEach(function (remve_lang_head){
    remve_lang_head.closest('localization-form').classList.remove('active');
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
function quickAddButton(){
    if(document.querySelectorAll('.variant-grid')) document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      if (sizeList.dataset.quickaddInitialized === "true") return;
      sizeList.dataset.quickaddInitialized = "true";
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        if(sizeList.closest('.snippet-product-grid')){
          sizeList.closest('.snippet-product-grid').querySelectorAll('.variant-grid').forEach((sizeListRm) => {
            sizeListRm.classList.remove('active');
          });
        }else{
          const variantGrids = sizeList.closest('.grid-variant-outer')?.querySelectorAll('.variant-grid');
          if (variantGrids) {
            variantGrids.forEach((sizeListRm) => {
              sizeListRm.classList.remove('active');
            });
          }
        }
        sizeList.classList.add('active');
        let variant_id = sizeList.dataset.id;
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          cartNotification(data.items[0].id);
          if(!sizeList.closest('.pdp_mb_variant')){
            setTimeout(function(e){
              sizeList.closest('.snippet-product-grid').classList.remove('view_sizes');
            },200);
          }
          document.querySelector('body').classList.remove('open-quick-buy');
          if(document.location.href.indexOf('/cart') > -1) {
            window.location.href = "/cart";
          }else{
            if(typeof load_cart == 'function'){
              if(sizeList.closest('.pdp_mb_variant')){
                document.body.classList.remove('open-mb-size');
              }
              load_cart();
              checkMultipleSizesAndTriggerPopup();
              // setTimeout(function(e){
              //   document.querySelector('body').classList.add('open-drawer');
              // },500);
            }else{
              window.location.href = "/cart";
            }          
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  if(document.querySelectorAll('.quick_add')) document.querySelectorAll('.quick_add').forEach((quick_add) => {
    quick_add.addEventListener('mouseenter',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      quick_add.closest('.snippet-product-grid').classList.add('view_sizes');
    });
  });
  if(document.querySelector('.snippet-product-grid')) document.querySelectorAll('.snippet-product-grid').forEach(function(grid_col){
    grid_col.addEventListener('mouseleave', function(){
      if(grid_col.classList.contains('view_sizes')) grid_col.classList.remove('view_sizes');
      if(grid_col.querySelector('.variant-grid.active')) grid_col.querySelector('.variant-grid.active').classList.remove('active');
    });
  });
  var counttime = 0;
  function cartNotification(cartId){
    fetch(window.Shopify.routes.root + "?section_id=cart-notification")
    .then((response) => response.text())
    .then((responseText) => {
      const cnID = "cart-notification";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart_popup");
      const source = html.getElementById(cnID);
      if(source && destination) destination.innerHTML = source.innerHTML;
      let lastItem = document.querySelector(".ch_items .cn_" + cartId).innerHTML;
      if(lastItem) document.querySelector(".ch_items").innerHTML = lastItem;
      if(window.innerWidth > 991){
        if(document.querySelector('body').classList.contains('sticky-filter')){
          if(document.querySelector('body').classList.contains('scroll-down')){
            document.querySelector(".cart_popup").style.top = (document.querySelector('.snippet-collection-filter').offsetHeight+12)+'px';
          }else{
            document.querySelector(".cart_popup").style.top = (document.querySelector('.header-group-wrap').offsetHeight+document.querySelector('.snippet-collection-filter').offsetHeight+12)+'px';
          }
        }else{
          document.querySelector(".cart_popup").style.top = (document.querySelector('.header-group-wrap').offsetHeight+12)+'px';
        }
      }
      if(document.querySelector(".cart-notification")){
        setTimeout(() => {
          // document.querySelector(".cart_popup").classList.add("active");
           document.querySelector("body").classList.add("open-drawer");
        }, 1000);
      }
      counttime = 0;
      const myInterval = setInterval(timer, 1000);
      function timer(){
        counttime++;
        if(counttime > 5){
          document.querySelector(".cart_popup").classList.remove("active");
          setTimeout(() => {
            document.querySelector(".cart_popup").innerHTML = "";
          }, 3000);
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }
      document.body.addEventListener("click", function(e){
        var popup = document.querySelector(".cart_popup");
        if(!popup.contains(event.target)){
          popup.innerHTML = "";
        }
      });
      if(document.querySelector('.cn_close')) document.querySelector('.cn_close').addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector(".cart_popup").classList.remove("active");
        document.querySelector(".cart_popup").innerHTML = "";
      });
      if(document.querySelector('.cn_btn')) document.querySelector('.cn_btn').addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector(".cart_popup").classList.remove("active");
        document.querySelector(".cart_popup").innerHTML = "";
        document.querySelector('body').classList.add('open-drawer');
      });
    });
  }
  let images = document.querySelectorAll(".product-images img:not(.second-image)");
  images.forEach((img) => {
    if(img.complete){
      img.classList.add("loaded");
    }else{
      img.addEventListener("load", () => img.classList.add("loaded"));
    }
  });
}
quickAddButton();
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
if(document.querySelector('.wpp-meta-ul')){
  const listItems = document.querySelectorAll('.wpp-meta-ul li');
  listItems.forEach(li => {
      li.addEventListener('click', function () {
          console.log('Clicked variant:');
      });
  });
}
document.querySelectorAll('.back-odlist').forEach(function(backodbtn) {
  backodbtn.addEventListener('click', function() {
    const activenav = 'ordersnav';
    localStorage.setItem('activenav', activenav);
     window.history.back();
  });
});
window.addEventListener("load", (event) => {
  const retrievedObject = localStorage.getItem('activenav');
  if(retrievedObject){
    document.querySelectorAll('.acc-nav p').forEach(function(nav){
      nav.classList.remove('active-nav');
    });
    document.querySelectorAll('.account-bottom .account-list').forEach(function(newactive){
      newactive.classList.remove('active-acc');
    });
    document.querySelectorAll('.acc-nav p').forEach(function(nav){
      const navId = nav.getAttribute('nav-id');
      if(navId === retrievedObject){
        nav.classList.add('active-nav');
      }
    });
    document.querySelectorAll('.account-bottom .account-list').forEach(function(newactive){
      const newactiveId = newactive.getAttribute('data-list-id');
      if (newactiveId === retrievedObject){
        newactive.classList.add('active-acc');
      }
    });
    setTimeout(function() {
      localStorage.removeItem('activenav');
    }, 1000);
  }
});


document.addEventListener("DOMContentLoaded", () => {
  
  function initAccordions(container = document) {
    container.querySelectorAll(".cart-accordion").forEach(acc => {
      
      if (acc.dataset.accordionInit === "true") return;
      acc.dataset.accordionInit = "true";

      const title = acc.querySelector(".accordian-title");
      const content = acc.querySelector(".accordian-content");
      const icon = acc.querySelector(".icon");

      if (!title || !content || !icon) return;

      title.addEventListener("click", () => {
        const isOpen = acc.classList.contains("active");

        document.querySelectorAll(".cart-accordion").forEach(a => {
          a.classList.remove("active");
          a.querySelector(".icon").textContent = "+";
          a.querySelector(".accordian-content").style.maxHeight = null;
        });

        if (!isOpen) {
          acc.classList.add("active");
          content.style.maxHeight = content.scrollHeight + "px";
          icon.textContent = "-";
        }
      });
    });
  }

  
  initAccordions();

  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(".cart-accordion")) {
          initAccordions(node.parentNode);
        } else if (node.querySelector && node.querySelector(".cart-accordion")) {
          initAccordions(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const SELECTOR = ".cd-rgt .cart-checkout-button";
//   let io = null;            
//   let observedEl = null; 


//   function observeElement(el) {
 
//     if (observedEl === el) return;

//     if (io) {
//       io.disconnect();
//       io = null;
//     }

//     io = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         document.body.classList.toggle("visible", entry.isIntersecting);
//       });
//     }, { root: null, threshold: 0.01 });

//     io.observe(el);
//     observedEl = el;
//   }

//   function stopObserving() {
//     if (io) {
//       io.disconnect();
//       io = null;
//     }
//     observedEl = null;
//     document.body.classList.remove("visible");
//   }

//   const mo = new MutationObserver(() => {
//     const el = document.querySelector(SELECTOR);
//     if (el) {
//       observeElement(el);
//     } else {
//       if (observedEl) stopObserving();
//     }
//   });


//   mo.observe(document.body, { childList: true, subtree: true });

//   const existing = document.querySelector(SELECTOR);
//   if (existing) observeElement(existing);
// });

(function () {
  const body = document.body;
  const isCollection = body.classList.contains('template-collection');
  const isProduct = body.classList.contains('template-product');

  if (isCollection) {
    sessionStorage.setItem('lastCollection', body.dataset.collectionHandle || '');
    sessionStorage.setItem('lastCollectionIsNewLaunch', body.dataset.isNewLaunch || 'false');
  } else if (!isProduct) {
    sessionStorage.removeItem('lastCollection');
    sessionStorage.removeItem('lastCollectionIsNewLaunch');
  }

  if (isProduct) {
    const lastColl = sessionStorage.getItem('lastCollection') || '';
    if (lastColl.includes('sale')) {
      document.querySelectorAll('.main-nav li.sale-link, .hb-item.sale-link, .md-highlight.sale-link').forEach(function (el) {
        el.classList.add('sale-collection-ea');
      });
      document.querySelectorAll('.sub-nav-wrap.sale-link').forEach(function (el) {
        el.classList.remove('sale-link');
      });
    }
    if (sessionStorage.getItem('lastCollectionIsNewLaunch') === 'true') {
      document.querySelectorAll('.main-nav li.new-launch-link, .hb-item.new-launch-link, .md-highlight.new-launch-link').forEach(function (el) {
        el.classList.add('new-launch-collection');
      });
    }
  }
})();